export * from './NewsList';
